import type {
  BarSeriesOption,
  GaugeSeriesOption,
  LineSeriesOption,
  PieSeriesOption,
  ScatterSeriesOption,
} from 'echarts/charts';
import type {
  DatasetComponentOption,
  GridComponentOption,
  LegendComponentOption,
  TitleComponentOption,
  ToolboxComponentOption,
  TooltipComponentOption,
} from 'echarts/components';
import type { ComposeOption } from 'echarts/core';
import type { SingleAxisOption } from 'echarts/types/dist/shared';
import type { BarSeriesLabelOption } from 'echarts/types/src/chart/bar/BarSeries.js';
import type { OptionName } from 'echarts/types/src/util/types.js';

// reference: https://echarts.apache.org/handbook/en/basics/import/#creating-an-option-type-in-typescript
type BaseOption =
  | DatasetComponentOption
  | GridComponentOption
  | LegendComponentOption
  | TitleComponentOption
  | ToolboxComponentOption
  | TooltipComponentOption;
export type BarChartOption = ComposeOption<BarSeriesOption | BaseOption>;
export type GaugeChartOption = ComposeOption<GaugeSeriesOption | BaseOption>;
export type LineChartOption = ComposeOption<LineSeriesOption | BaseOption>;
export type PieChartOption = ComposeOption<PieSeriesOption | BaseOption>;
export type ScatterChartOption = ComposeOption<ScatterSeriesOption | SingleAxisOption | BaseOption>;

export class BarData {
  public name = 'Percentage';
  public type = 'bar' as const;
  public label?: BarSeriesLabelOption;

  public data: number[];
  public totals: number[];

  constructor(data: number[], totals: number[]) {
    this.data = data;
    this.totals = totals;
  }
}

export class CategoryData {
  public type = 'category';
  public data: string[];

  constructor(data: string[]) {
    this.data = data;
  }
}

export type LineChartData =
  | {
      data: string[];
      type: 'category';
      name: string | null;
    }
  | {
      data: number[];
      type: 'line';
      name: OptionName | undefined;
    };
